import CopyButton from '@/src/components/AppComponents/CopyButton/CopyButton';
import OpenInNewTabButton from '@/src/components/AppComponents/OpenInNewTabButton/OpenInNewTabButton';
import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import NumberInput from '@/src/components/Commons/Controllers/NumberInput/NumberInput';
import { formatHash } from '@/src/lib/SmartDB/Commons/formatters';
import { TaskComponentProps, TxComponentProps } from '@/src/types/index';
import { TOKEN_ADA_DECIMALS, TOKEN_ADA_TICKER } from '@/src/lib/SmartDB/Commons/Constants/constants';
import styles from './GetADA.module.scss';
import useUserGetADATx from './useGetADA';
import TxProcessing from '../../TxProcessing';
import { ROUTES } from '@/src/utils/routes';
import { useRouter } from '@/src/store/router/RouterProvider';

export default function UserGetADATx({ ...props }: {} & TxComponentProps & TaskComponentProps) {
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const {
        appStore,
        isRefreshing,
        isProcessingTx,
        isFaildedTx,
        setIsFaildedTx,
        isConfirmedTx,
        setIsConfirmedTx,
        processingTxMessage,
        processingTxHash,
        isValidTx,
        amount,
        setAmount,
        handleBtnGetADATx,
    } = useUserGetADATx({ ...props });
    //--------------------------------------
    return (
        <>
            {isProcessingTx || isConfirmedTx || isFaildedTx ? (
                <>
                    <TxProcessing
                        isProcessingTx={isProcessingTx}
                        processingTxMessage={processingTxMessage}
                        processingTxHash={processingTxHash}
                        isFaildedTx={isFaildedTx}
                        setIsFaildedTx={setIsFaildedTx}
                        isConfirmedTx={isConfirmedTx}
                        setIsConfirmedTx={setIsConfirmedTx}
                        onFinishTask={props.onFinishTask}
                        showNewTransactionButton={true}
                        nameForNewTransactionButton={`Get more ${TOKEN_ADA_TICKER}`}
                        nameForCloseButton="Close"
                        othersButtonsWhenConfirmed={
                            <>
                                <Button
                                    mode="action"
                                    size="large"
                                    width={200}
                                    onClick={async () => {
                                        await router.push({
                                            pathname: ROUTES.PORTFOLIO,
                                        });
                                    }}
                                >
                                    View Portfolio
                                </Button>
                            </>
                        }
                    />
                </>
            ) : (
                <>
                    <table className={styles.tableFormModal}>
                        <thead>
                            <tr>
                                <th colSpan={2}>Get {TOKEN_ADA_TICKER}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Amount</td>
                                <td>
                                    <NumberInput decimals={TOKEN_ADA_DECIMALS} value={amount} setValue={(value) => setAmount(value)} />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <div className={styles.buttonsBelowForm}>
                                        <Button
                                            mode="action"
                                            size="large"
                                            onClick={() => {
                                                handleBtnGetADATx();
                                            }}
                                            disabled={!isValidTx}
                                        >
                                            Confirm
                                        </Button>
                                        <Button mode="action" size="large" onClick={props.onCancel}>
                                            Cancel
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
        </>
    );
    //--------------------------------------
}
